export default __webpack_public_path__ + "static/livewire-4cf7ef8ec74fe0c4b3c70054dded90a0.gif";